module.exports = __webpack_public_path__ + "static/media/background.68a76444.png";